"use client";
import { AppRouterCacheProvider } from "@mui/material-nextjs/v15-appRouter";
import { Poppins } from "next/font/google";
import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline, Box } from "@mui/material";

import theme from "../theme";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SnackbarWrapper from "@/components/SnackbarWrapper";
import ClientOnly from "@/components/ClientOnly";
import Script from "next/script";

const poppins = Poppins({
  weight: ["300", "400", "500", "700"],
  subsets: ["latin"],
  display: "swap",
  variable: "--font-poppins",
});

export const RECAPTCHA_SITE_KEY = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY!;
export default function RootLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  return (
    <html lang="en" className={poppins.variable}>
      <body>
        <AppRouterCacheProvider>
          <Script
            id="recaptcha"
            src={`https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`}
            strategy="afterInteractive"
          />
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <ClientOnly>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  minHeight: "100vh",
                }}>
                <Header />
                <Box component="main" sx={{ flex: 1 }}>
                  <SnackbarWrapper>{children}</SnackbarWrapper>
                </Box>
                <Footer />
              </Box>
            </ClientOnly>
          </ThemeProvider>
        </AppRouterCacheProvider>
      </body>
    </html>
  );
}
